var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var NetworkManager = require('./NetworkManager.js');
var LinkingManager = require('./wrappers/LinkingManager');

import Icon from './wrappers/ReUpIcon';
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpField = require('./ReUpField.js')
var ReUpButton = require('./ReUpButton.js')
var ReUpStyle = require('./ReUpStyle.js')
var ReUpText = require('./ReUpText.js');
var ShadowView = require('./ShadowView.js');
var ProgressOverlay = require('./ProgressOverlay.js');
var LinkingManager = require('./wrappers/LinkingManager');
var AnalyticsManager = require('./AnalyticsManager');
var Hyperlink = require('./wrappers/react-native-hyperlink-wrapper');
var Keyboard = require('./wrappers/Keyboard-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKIconToggle,
  MKCheckbox,
  MKButton
} = MK;

const FBSDK = require('./wrappers/react-native-fbsdk-wrapper');
const {
  LoginManager,
  AccessToken,
} = FBSDK;

var {
  AppRegistry,
  Text,
  View,
  StyleSheet,
  AppState
} = ReactNative;

var CreateUser = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    var locManager = this.props.appManager.getLocalizationManager();
    var initialEmailErrorString = locManager.localizedStringForKey("VALID_EMAIL_STRING_ERROR");
    return {
      layout : this.props.initialLayout,
      showPassword : false,
      showRefCode : false,
      fadeRefCode : new Animated.Value(0),
      nameError : false,
      firstNameError : false,
      lastNameError : false,
      emailError : false,
      emailErrorString: initialEmailErrorString,
      passwordError : false,
      refCodeErrorString: '',
      shouldShowSpinner: false,
      spinnerText: '',
      canOpenMailApp: false,
      optedIn: false,
      signingUpWithEmail:!this.props.appManager.useFacebookForFeatureName("CreateUser"),
    }
  },

  componentDidMount : function()
  {
    AppState.addEventListener('change', this._handleAppStateChange);
    this.didUpdate();
    if( typeof this.props.extras === 'undefined' || !this.props.extras.useInterstitialFlow )
    {
      var thisThing = this;
      setTimeout(function()
      {
        thisThing.focus();
      }, 400)
    }
  },

  componentWillUnmount : function()
  {
    AppState.removeEventListener('change', this._handleAppStateChange);
    this._shouldContinueRecuriveLogin = false;
    clearTimeout(this._recursiveLoginTimeout);
  },

  _handleAppStateChange : function(appState)
  {
    if( appState == 'active' )
    {

    }
    else
    {

    }
  },

  didUpdate : function(data)
  {
  },

  focus : function()
  {
    if( this.refs.firstName ) this.refs.firstName.focus();
  },

  _email : "",
  emailChanged : function(text)
  {
    if( this.props.appManager.isValidEmail(text) ) this._enableEmailError = true;
    this._email = text;

    var newState = this.checkErrors();
    if ( this.state.emailError != newState.emailError )
    {
      this.setState(newState);
    }
  },

  _firstName : "",
  firstNameChanged : function(text)
  {
    var firstNameValid = this._firstName.length > 0;
    if( firstNameValid ) this._enableFirstNameError = true;

    this._firstName = text;
    var newState = this.checkErrors();
    if ( this.state.firstNameError !== newState.firstNameError )
    {
      this.setState(newState);
    }
  },

  _lastName : "",
  lastNameChanged : function(text)
  {
    var lastNameValid = this._lastName.length > 0;
    if( lastNameValid ) this._enableLastNameError = true;

    this._lastName = text;
    var newState = this.checkErrors();
    if ( this.state.lastNameError !== newState.lastNameError )
    {
      this.setState(newState);
    }
  },

  _password : "",
  passwordChanged : function(text)
  {
    if( this.props.appManager.isValidPassword(text) ) this._enablePasswordError = true;

    this._password = text;
    var newState = this.checkErrors();
    if ( this.state.passwordError != newState.passwordError )
    {
      this.setState(newState);
    }
  },

  _refCode : "",
  refCodeChanged: function(text)
  {
    this._refCode = text;
  },

  _enableFirstNameError : false,
  _enableLastNameError : false,
  _enableEmailError : false,
  _enablePasswordError : false,
  _enableInlineErrors : false,
  checkErrors : function()
  {
    var firstNameError = this._enableFirstNameError && !this._firstName.length > 0;
    var lastNameError = this._enableLastNameError && !this._lastName.length > 0;
    var emailError = this._enableEmailError && !this.props.appManager.isValidEmail(this._email);
    var passwordError = this._enablePasswordError && !this.props.appManager.isValidPassword(this._password);

    return {emailError:emailError, firstNameError:firstNameError, lastNameError:lastNameError, passwordError:passwordError};
  },

  showRefCodeField: function()
  {
    var thisThing = this;
    thisThing.setState({showRefCode: !thisThing.state.showRefCode})
    Animated.timing(
      this.state.fadeRefCode,
      {
        toValue: 1,
        duration: 500,
      },
    ).start(function()
    {
      thisThing.refs.refCode.focus();
    });
  },

  showEmailSpinnerAndMessage: function(email)
  {
    var thisThing = this;
    var locMan = this.props.appManager.getLocalizationManager();
    var spinnerText = locMan.localizedStringForKey("VERIFY_EMAIL_HUD_TITLE");
    var spinnerBody = locMan.localizedStringForKeyAndParams("VERIFY_EMAIL_HUD_BODY", [email]);
    this.checkForMailApp((can)=>
    {
      thisThing.showSpinnerAndMessage(spinnerText, spinnerBody, can);
    })
  },

  showSpinnerAndMessage: function(spinnerText, spinnerBody, showMail)
  {
    Keyboard.dismiss();
    this.setState({shouldShowSpinner: true, spinnerText: spinnerText, spinnerBody: spinnerBody, canOpenMailApp: showMail})
  },

  hideSpinnerAndMessage: function()
  {
    this.setState({shouldShowSpinner: false})
  },

  checkForMailApp: function(completion)
  {
    var thisThing = this;
    var mailURL = "message://";
    LinkingManager.canOpenURL(mailURL, function(can)
    {
      thisThing.setState({canOpenMailApp:can})
      completion(can);
    })
  },

  submitPressed : function()
  {
    this._enableEmailError = true;
    this._enableFirstNameError = true;
    this._enableLastNameError = true;
    this._enablePasswordError = true;

    var newState = this.checkErrors();
    this.setState(newState);
    var thisThing = this;
    var appActions = this.props.appActions;
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras.useInterstitialFlow;

    if( newState.firstNameError )
    {
      if ( !useInterstitialFlow )
      {
        appActions.showLocalizedAlert("NAME_EMPTY_FAIL_ALERT_TITLE", "NAME_EMPTY_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
          if( thisThing.refs.firstName ) thisThing.refs.firstName.focus();
        }], function(){})
      }
    }
    else if( newState.lastNameError )
    {
      if ( !useInterstitialFlow )
      {
        appActions.showLocalizedAlert("NAME_EMPTY_FAIL_ALERT_TITLE", "NAME_EMPTY_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
          if( thisThing.refs.lastName ) thisThing.refs.lastName.focus();
        }], function(){})
      }
    }
    else if( newState.emailError )
    {
      if ( !useInterstitialFlow )
      {
        appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
          if( thisThing.refs.email ) thisThing.refs.email.focus();
        }], function(){})
      }
    }
    else if( newState.passwordError )
    {
      if ( !useInterstitialFlow )
      {
        appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE", "CHANGE_PASS_FORMAT_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
          if( thisThing.refs.password ) thisThing.refs.password.focus();
        }], function(){})
      }
    }
    else
    {
      var appManager = this.props.appManager;
      var locManager = appManager.getLocalizationManager();
      var email = this._email;
      var password = this._password;
      var registering = appManager.getLocalizationManager().localizedStringForKey("REGISTERING_HUD");

      this.showEmailSpinnerAndMessage(email);

      NetworkManager.createUser(this.props.appManager, this._email, this._password, this._firstName, this._lastName, "", this._refCode, this.state.optedIn,
      function(email)
      {
        if ( !useInterstitialFlow )
        {
          AnalyticsManager.logSignUpEvent(appManager, 'Normal', true);
          appActions.setSpinnerShown(false);
          appManager.setTempUserPass([email, password]);
          thisThing._shouldContinueRecuriveLogin = true;
          thisThing.recursiveLogin(thisThing.props.appManager, thisThing._email, thisThing._password, (data)=>
          {
            data[ModelConstants.Password] = password;
            appManager.setCurrentUser(data, function()
            {
              thisThing.hideSpinnerAndMessage();
              var addCreditFeature = appManager.getFeatureForName("AddCredit");
              if( typeof addCreditFeature !== 'undefined' )
              {
                appActions.requestFeatureName("AddCredit", {}, true, null, true);
              }
            })
          });
        }
        else
        {
          appManager.setTempUserPass([email, password]);
          AnalyticsManager.logSignUpEvent(appManager, 'Interstitial', true);
          thisThing._shouldContinueRecuriveLogin = true;
          thisThing.recursiveLogin(thisThing.props.appManager, thisThing._email, thisThing._password, (data)=>
          {
            data[ModelConstants.Password] = password;
            appManager.setCurrentUser(data, function()
            {
              thisThing.props.extras.createUserDidFinish();
            })
          });
        }
      }, function(data)
      {
        if ( !useInterstitialFlow )
        {
          AnalyticsManager.logSignUpEvent(appManager, 'Normal', false, {error:data.code});
          appActions.setSpinnerShown(false);
          thisThing.setState({shouldShowSpinner: false});
          if( data.code == -4 )
          {
            // not verified or account already created, so lets try to log them in anyways
            NetworkManager.login(thisThing.props.appManager, thisThing._email, thisThing._password, function(data)
            {
              data[ModelConstants.Password] = password;
              appManager.setCurrentUser(data, function()
              {
                thisThing.hideSpinnerAndMessage();
                var addCreditFeature = appManager.getFeatureForName("AddCredit");
                if( typeof addCreditFeature !== 'undefined' )
                {
                  appActions.requestFeatureName("AddCredit", {}, true, null, true);
                }
                else
                {
                  appActions.requestPopToIndex(0);
                }
              })
            }, function(data)
            {
              thisThing.refs.email.setIsInError(true);
              appActions.showLocalizedAlert("CREATEUSER_EXISTS_FAIL_ALERT_TITLE", "CREATEUSER_EXISTS_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
              {
                appActions.hideAlert();
                thisThing.refs.email.focus();
              }], function(){})
            }, function(data)
            {
              thisThing.refs.email.setIsInError(true);
              appActions.showLocalizedAlert("CREATEUSER_EXISTS_FAIL_ALERT_TITLE", "CREATEUSER_EXISTS_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
              {
                appActions.hideAlert();
                thisThing.refs.email.focus();
              }], function(){})
            });
          }
          else if( data.code == -44 )
          {
            thisThing.refs.refCode.setIsInError(true);
            appActions.showLocalizedAlert("Referral Code Invalid!", "Please enter a valid referral code or clear the field.", ["OK_ALERT_BUTTON"], [function()
            {
              appActions.hideAlert();
              thisThing.refs.refCode.focus();
            }], function(){})
          }
          else
          {
            thisThing.refs.email.setIsInError(true);
            appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
            {
              appActions.hideAlert();
              thisThing.refs.email.focus();
            }], function(){})
          }
        }
        else
        {
          AnalyticsManager.logSignUpEvent(appManager, 'Interstitial', false, {error:data.code});
          thisThing.setState({shouldShowSpinner: false});
          if( data.code == -4 )
          {
            // not verified or account already created, so lets try to log them in anyways
            NetworkManager.login(thisThing.props.appManager, thisThing._email, thisThing._password, function(data)
            {
              data[ModelConstants.Password] = password;
              appManager.setCurrentUser(data, function()
              {
                thisThing.props.extras.createUserDidFinish(null, true);
              })
            }, function(data)
            {
              var errorStringLocalized = locManager.localizedStringForKey("CREATEUSER_EXISTS_FAIL_ALERT_BODY");
              thisThing.setState({emailError: true, emailErrorString: errorStringLocalized});
              thisThing.refs.email.focus();
            }, function(data)
            {
              var errorStringLocalized = locManager.localizedStringForKey("CREATEUSER_EXISTS_FAIL_ALERT_BODY");
              thisThing.setState({emailError: true, emailErrorString: errorStringLocalized});
              thisThing.refs.email.focus();
            });
          }
          else if( data.code == -44 )
          {
            var errorStringLocalized = locManager.localizedStringForKey("VALID_REFFERAL_CODE_ERROR");
            thisThing.setState({refCodeError: true, refCodeErrorString: errorStringLocalized});
            thisThing.refs.refCode.focus();
          }
          else if( typeof data.code === 'undefined' )
          {
            thisThing.props.extras.showNetworkErrorAlert();
          }
          else
          {
            var errorStringLocalized = locManager.localizedStringForKey("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY");
            thisThing.setState({emailError: true, emailErrorString: errorStringLocalized});
            thisThing.refs.email.focus();
          }
        }
      }, function(data)
      {
        if ( !useInterstitialFlow )
        {
          AnalyticsManager.logSignUpEvent(appManager, 'Normal', false);
          appActions.setSpinnerShown(false);
          appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
        }
        else
        {
          AnalyticsManager.logSignUpEvent(appManager, 'Interstitial', false);
          thisThing.setState({shouldShowSpinner: false});
          thisThing.props.extras.showNetworkErrorAlert();
        }
      })
    }
  },

  setScrollOffset: function(yOffset)
  {
    var thisThing = this;
    setTimeout(function()
    {
      var minScrollOffset = 0;
      var keyboardOffset = typeof thisThing.refs.ptr !== 'undefined' ? thisThing.refs.ptr._keyboardOffset : 0;
      var maxScrollOffset = thisThing._contentHeight - (thisThing._scrollViewHeight - keyboardOffset);
      var normalizedScroll = Math.max(minScrollOffset, Math.min(maxScrollOffset, yOffset));

      thisThing.refs.ptr.scrollTo(0,normalizedScroll);
    },100)
  },

  openTosLink: function(url)
  {
    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
    LinkingManager.canOpenURL(url, function(can)
    {
      if( can )
      {
        LinkingManager.openURL(url, tintColor, barTintColor)
      }
    });
  },

  _recursiveLoginPaused: false,
  setRecursiveLoginPaused: function(paused)
  {
    if( paused != this._recursiveLoginPaused )
    {
      if( paused ) // can only pause if there is login info recorded
      {
        if( this._loginInfoForPause != null )
        {
          this._recursiveLoginPaused = paused;
          clearTimeout(this._recursiveLoginTimeout);
        }
      }
      else
      {
        this._recursiveLoginPaused = paused;
        if( this._loginInfoForPause != null ) // can only resume if login info is recorded
        {
          this.recursiveLogin(this._loginInfoForPause.appManager, this._loginInfoForPause.email, this._loginInfoForPause.password, this._loginInfoForPause.didLogin )
        }
      }
    }
  },

  _shouldContinueRecuriveLogin : false,
  _recursiveLoginTimeout : null,
  _loginInfoForPause:null,
  recursiveLogin: function(appManager, email, password, didLogin)
  {
    if( !this._shouldContinueRecuriveLogin || this._recursiveLoginPaused ) return;

    this._loginInfoForPause = {appManager:appManager, email:email, password:password, didLogin:didLogin};
    var thisThing = this;
    NetworkManager.login(appManager, email, password, function(data)
    {
      didLogin(data);
    }, function(data)
    {
      thisThing._recursiveLoginTimeout = setTimeout(()=>
      {
        thisThing.recursiveLogin(appManager, email, password, didLogin);
      }, 1000)
    }, function(data)
    {
      thisThing._recursiveLoginTimeout = setTimeout(()=>
      {
        thisThing.recursiveLogin(appManager, email, password, didLogin);
      }, 1000)
    });
  },

  submitFacebookPressed : function()
  {
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var thisThing = this;
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras.useInterstitialFlow;
    this.showSpinnerAndMessage("","");
    LoginManager.logInWithReadPermissions(['email','public_profile']).then(
    function(result)
    {
      if (result.isCancelled)
      {
        console.log("Facebook cancelled")
        thisThing.hideSpinnerAndMessage();
      }
      else
      {
        AccessToken.getCurrentAccessToken().then(
          (data) =>
          {
            var password = data.accessToken.toString();
            NetworkManager.createUserFacebook( appManager, password, thisThing._refCode, thisThing.state.optedIn, (email)=>
            {
              NetworkManager.login(appManager, email, password, (data)=>
              {
                data[ModelConstants.Password] = password;
                if ( !useInterstitialFlow )
                {
                  AnalyticsManager.logSignUpEvent(appManager, 'Normal-Facebook', true);
                  appManager.setCurrentUser(data, function()
                  {
                    thisThing.hideSpinnerAndMessage();
                    var addCreditFeature = appManager.getFeatureForName("AddCredit");
                    if( typeof addCreditFeature !== 'undefined' )
                    {
                      appActions.requestFeatureName("AddCredit", {}, true, null, true);
                    }
                    else
                    {
                      appActions.requestPop(true);
                    }
                  })
                }
                else
                {
                  AnalyticsManager.logSignUpEvent(appManager, 'Interstitial-Facebook', true);
                  appManager.setCurrentUser(data, function()
                  {
                    thisThing.hideSpinnerAndMessage();
                    thisThing.props.extras.createUserDidFinish();
                  })
                }
              }, ()=>
              {
                thisThing.hideSpinnerAndMessage();
              }, ()=>
              {
                thisThing.hideSpinnerAndMessage();
              })
            }, ()=>
            {
              thisThing.hideSpinnerAndMessage();
            })
          }
        )
      }
    },
    function(error)
    {
      thisThing.hideSpinnerAndMessage();
      console.log('Login fail with error: ' + error);
    }
  );
  },

  _firstNameError : false,
  _secondNameError : false,
  _emailError : false,
  _passwordError : false,
  render: function()
  {
    var createUser = this;
    var appManager = this.props.appManager;
    var featureData = appManager.getFeatureForName("CreateUser");
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var appInfo = appManager.getAppInfo();
    var tosLink = appManager.getTermsLink();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);

    var firstNameLabel = locManager.localizedStringForKey("FIRSTNAME_PLACEHOLDER");
    var lastNameLabel = locManager.localizedStringForKey("LASTNAME_PLACEHOLDER");
    var emailLabel = locManager.localizedStringForKey("USERNAME_PLACEHOLDER");
    var passwordLabel = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER");
    var fillInFirstNameInstruction = locManager.localizedStringForKey("FILL_IN_FIRST_NAME_INSTRUCTION");
    var fillInLastNameInstruction = locManager.localizedStringForKey("FILL_IN_LAST_NAME_INSTRUCTION");
    var passwordEightCharInstruction = locManager.localizedStringForKey("PW_EIGHT_CHAR_INSTRUCTION");
    var openEmailButton = locManager.localizedStringForKey("OPEN_EMAIL_BUTTON");
    var registerButton = featureData.data.title;
    var refCodeButton = locManager.localizedStringForKey("REFERRAL_CODE_LABEL") + "?";
    var mailURL = "message://"
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras.useInterstitialFlow;
    var optInText = locManager.localizedStringForKeyAndParams("OPT_IN_CHECK", [appManager.appNameLong]);
    if( typeof optInText === 'undefined' || optInText == "OPT_IN_CHECK" )
    {
      optInText = locManager.localizedStringForKeyAndParams("OPT_IN_CHECK", [appManager.appNameLong]);
    }

    var fieldHeightForAutoScroll = 60;

    if( this.state.signingUpWithEmail )
    {
      return (
        <View style={[styles.container, {backgroundColor: generalColor}]}>
          { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
          <ReUpScrollView ref="ptr" bounces={true} responder={this} onLayout={(event)=>this._scrollViewHeight = event.nativeEvent.layout.height}>
              <ShadowView appManager={appManager} layout={this.state.layout} />
              <View onLayout={(event)=>this._contentHeight = event.nativeEvent.layout.height} >
                <View key="fields" style={styles.fieldsContainer}>
                  <View style={{flexDirection:'row'}}>
                    <View style={{flexDirection:'column', flex:1}}>
                      <ReUpField
                        appManager={appManager}
                        underlineColorAndroid='transparent'
                        key="firstName" ref="firstName"
                        autoCapitalize={'words'}
                        autoCorrect={false}
                        onFocus={()=>this.setScrollOffset(fieldHeightForAutoScroll*0)}
                        onChangeText={this.firstNameChanged}
                        onSubmitEditing={() => {this.refs.lastName.focus();}}
                        returnKeyType={'next'}
                        isInError={this.state.firstNameError}
                        placeholder={firstNameLabel}
                        style={[styles.textField, {flex:-1}]}/>
                      {
                      this.state.firstNameError && useInterstitialFlow ?
                        <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:'red', marginLeft:10}}>
                          {fillInFirstNameInstruction}
                        </ReUpText>
                      : null
                      }
                    </View>
                    <View style={{width:8}} />
                    <View style={{flexDirection:'column', flex:1}}>
                      <ReUpField
                        appManager={appManager}
                        underlineColorAndroid='transparent'
                        key="lastName" ref="lastName"
                        autoCapitalize={'words'}
                        autoCorrect={false}
                        onFocus={()=>this.setScrollOffset(fieldHeightForAutoScroll*0)}
                        onChangeText={this.lastNameChanged}
                        onSubmitEditing={() => {this.refs.email.focus();}}
                        returnKeyType={'next'}
                        isInError={this.state.lastNameError}
                        placeholder={lastNameLabel}
                        style={[styles.textField, {flex:-1}]}/>
                      {
                        this.state.lastNameError && useInterstitialFlow ?
                          <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:'red', marginLeft:10}}>
                            {fillInLastNameInstruction}
                          </ReUpText>
                        : null
                      }
                    </View>
                  </View>
                  <ReUpField
                    appManager={appManager}
                    key="email" ref="email"
                    underlineColorAndroid='transparent'
                    autoCapitalize={'none'}
                    autoCorrect={false}
                    onFocus={()=>this.setScrollOffset(fieldHeightForAutoScroll*1)}
                    keyboardType={'email-address'}
                    onChangeText={this.emailChanged}
                    onSubmitEditing={() => {this.refs.password.focus();}}
                    returnKeyType={'next'}
                    placeholder={emailLabel}
                    isInError={this.state.emailError}
                    style={[styles.textField]}/>
                  {
                    this.state.emailError && useInterstitialFlow ?
                      <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:'red', marginLeft:10}}>
                        {this.state.emailErrorString}
                      </ReUpText>
                    : null
                  }
                  <View style={styles.passwordContainer}>
                    <ReUpField
                      appManager={appManager}
                      underlineColorAndroid='transparent'
                      onChangeText={this.passwordChanged}
                      onSubmitEditing={this.state.showRefCode ? () => {this.refs.refCode.focus();} : this.submitPressed}
                      returnKeyType={this.state.showRefCode ? 'next' : 'done'}
                      key="password"
                      ref="password"
                      onFocus={()=>this.setScrollOffset(fieldHeightForAutoScroll*2)}
                      isInError={this.state.passwordError}
                      placeholder={passwordLabel}
                      secureTextEntry={!this.state.showPassword}
                      style={[styles.textField]}/>

                    <MKIconToggle
                      style={{marginTop:22, height:30, width:30, position:'absolute', right:0, backgroundColor:'transparent'}}
                      checked={this.state.showPassword}
                      onCheckedChange=
                      {
                        this.state.showPassword ?
                        () => {createUser.setState({showPassword : false}); this.refs.password.onBlur(); this.refs.password.focus();}
                        :
                        () => {createUser.setState({showPassword : true}); this.refs.password.onBlur(); this.refs.password.focus();}
                      }
                      >
                      <Icon pointerEvents="none" state_checked={true} style={[styles.creditCardEditButtonIcon]} name={"eye"} size={14} color={generalTitleColor} />
                      <Icon pointerEvents="none" state_checked={false} style={[styles.creditCardEditButtonIcon]} name={"eye-slash"} size={14} color={generalTitleColor} />
                    </MKIconToggle>
                  </View>
                  {
                    this.state.passwordError && useInterstitialFlow ?
                      <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:'red', marginLeft:10}}>
                        {passwordEightCharInstruction}
                      </ReUpText>
                    : null
                  }
                  <View style={{flexDirection:'row', marginTop:10}}>
                    <MKButton onPress={() => { createUser.setState({optedIn:!createUser.state.optedIn}) }}
                      rippleColor={primaryButtonColorLight} maskBorderRadius={0} style={{
                        flexDirection:'row',
                        flex:1,
                        alignItems:'center',
                        height:40,
                        alignSelf:'center',
                        justifyContent:'center',
                      }}>
                      <MKCheckbox
                         checked={this.state.optedIn}
                         fillColor={generalTitleColor}
                         borderOnColor={generalTitleColor}
                         borderOffColor={generalTitleColor}
                         rippleColor={primaryButtonColorLight}
                        />
                      <View style={{flex:1, alignSelf:'center'}}>
                        <ReUpText appManager={appManager} style={{
                        }} numberOfLines={3}>{optInText}</ReUpText>
                      </View>
                    </MKButton>
                  </View>
                  {
                    this.state.showRefCode ?
                      <Animated.View
                        style={{
                          opacity: this.state.fadeRefCode,
                          marginBottom:10,
                        }}>
                        <ReUpField
                          appManager={appManager}
                          underlineColorAndroid='transparent'
                          key="refCode" ref="refCode"
                          autoCapitalize={'none'}
                          autoCorrect={false}
                          onFocus={()=>this.setScrollOffset(fieldHeightForAutoScroll*3)}
                          onSubmitEditing={this.submitPressed}
                          returnKeyType={'done'}
                          onChangeText={this.refCodeChanged}
                          placeholder={locManager.localizeStringForKey("REFERRAL_CODE_PLACEHOLDER")}
                          isInError={this.state.refCodeError}
                          style={[styles.textField]}/>
                      </Animated.View>
                    : <ReUpButton appManager={appManager} style={{marginHorizontal:0, marginTop:16}} text={refCodeButton} isSecondary={true}
                        onPress={this.showRefCodeField}
                      />
                  }
                  {
                    this.state.refCodeError && useInterstitialFlow ?
                      <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:'red', marginLeft:10}}>
                        {this.state.refCodeErrorString}
                      </ReUpText>
                    : null
                  }
                </View>
                <ReUpButton appManager={appManager} style={[styles.doneButton]} text={registerButton}
                  onPress={this.submitPressed}
                  />
                <Hyperlink
                  linkStyle={{ color: '#2980b9'}}
                  linkText={url => url === tosLink ? locManager.localizedStringForKey("TERMS_OF_SERVICE") : url}
                  onPress={(url) => createUser.openTosLink(url)}
                  >
                  <ReUpText appManager={appManager} style={{marginLeft:15, marginRight:15}}>
                  {locManager.localizedStringForKeyAndParams("BY_CREATING_ACCOUNT_STATEMENT", [tosLink])}
                  </ReUpText>
                </Hyperlink>
              </View>
            </ReUpScrollView>
          {
            this.state.shouldShowSpinner ?
              <ProgressOverlay ref="spinner" key="spinner" isVisible={this.state.shouldShowSpinner}
                spinnerText={this.state.spinnerText} spinnerBody={this.state.spinnerBody}
                layout={this.state.layout} appManager={appManager}>
                {
                  createUser.state.canOpenMailApp ?
                    <ReUpButton appManager={appManager} style={{justifyContent:'center', marginTop:6, padding:4}} text={openEmailButton}
                      onPress={function(){LinkingManager.openURL(mailURL)}}
                      />
                  : null
                }
              </ProgressOverlay>
            : null
          }
        </View>
      );
    }
    else
    {
      return (
        <View style={[styles.container, {backgroundColor: generalColor}]}>
          { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
          <ReUpScrollView ref="ptr" bounces={true} responder={this} onLayout={(event)=>this._scrollViewHeight = event.nativeEvent.layout.height}>
            <ShadowView appManager={appManager} layout={this.state.layout} />
            <View onLayout={(event)=>this._contentHeight = event.nativeEvent.layout.height} >
              <View key="fields" style={styles.fieldsContainer}>
                {
                  this.state.showRefCode ?
                    <Animated.View
                      style={{
                        opacity: this.state.fadeRefCode,
                        marginBottom:10,
                      }}>
                      <ReUpField
                        appManager={appManager}
                        underlineColorAndroid='transparent'
                        key="refCode" ref="refCode"
                        autoCapitalize={'none'}
                        autoCorrect={false}
                        onFocus={()=>this.setScrollOffset(fieldHeightForAutoScroll*3)}
                        onSubmitEditing={this.submitPressed}
                        returnKeyType={'done'}
                        onChangeText={this.refCodeChanged}
                        placeholder={locManager.localizeStringForKey("REFERRAL_CODE_PLACEHOLDER")}
                        isInError={this.state.refCodeError}
                        style={[styles.textField]}/>
                    </Animated.View>
                  : <ReUpButton appManager={appManager} style={{marginHorizontal:0, marginTop:16}} text={refCodeButton} isSecondary={true}
                      onPress={this.showRefCodeField}
                    />
                }
                {
                  this.state.refCodeError && useInterstitialFlow ?
                    <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:'red', marginLeft:10}}>
                      {this.state.refCodeErrorString}
                    </ReUpText>
                  : null
                }
              </View>
              <ReUpButton appManager={appManager} icon="facebook-official" iconSize={22} iconPaddingLeft={8} buttonColor="#244BA1" buttonTitleColor="white" style={[styles.doneButton, {marginBottom:0}]} text={locManager.localizedStringForKey("CONTINUE_WITH_FACEBOOK_BUTTON", "Continue With Facebook")}
                onPress={this.submitFacebookPressed}
                />
              <ShadowView layout={this.state.layout} text={locManager.localizedStringForKey("OR_LABEL")} appManager={appManager}/>
              <ReUpButton appManager={appManager} style={[styles.doneButton]} text={locManager.localizedStringForKey("SIGN_UP_WITH_EMAIL", "Sign Up With Email")}
                onPress={()=>
                {
                  createUser.setState({signingUpWithEmail:true});
                  setTimeout(()=>
                  {
                    createUser.focus();
                  }, 100)
                }}
                />
              <Hyperlink
                linkStyle={{ color: '#2980b9'}}
                linkText={url => url === tosLink ? locManager.localizedStringForKey("TERMS_OF_SERVICE") : url}
                onPress={(url) => createUser.openTosLink(url)}
                >
                <ReUpText appManager={appManager} style={{marginLeft:15, marginRight:15}}>
                {locManager.localizedStringForKeyAndParams("BY_CREATING_ACCOUNT_STATEMENT", [tosLink])}
                </ReUpText>
              </Hyperlink>
            </View>
          </ReUpScrollView>
          {
            this.state.shouldShowSpinner ?
              <ProgressOverlay ref="spinner" key="spinner" isVisible={this.state.shouldShowSpinner}
                spinnerText={this.state.spinnerText} spinnerBody={this.state.spinnerBody}
                layout={this.state.layout} appManager={appManager}>
                {
                  createUser.state.canOpenMailApp ?
                    <ReUpButton appManager={appManager} style={{justifyContent:'center', marginTop:6, padding:4}} text={openEmailButton}
                      onPress={function(){LinkingManager.openURL(mailURL)}}
                      />
                  : null
                }
              </ProgressOverlay>
            : null
          }
        </View>
      );
    }
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  backgroundView: {
    position: 'absolute',
    top:0, left:0, bottom:0, top:0
  },
  textField: {
    flex:1
  },
  fieldsContainer: {
    flexDirection:'column',
    paddingHorizontal:16,
    paddingVertical:10
  },
  passwordContainer: {
    flexDirection:'row',
  },
  passwordShowButton: {
    borderRadius:25,
    width:50,
    height:50,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf:'center',
    margin:4
  },
  doneButton: {
    justifyContent:'center',
    flex:1,
    marginHorizontal:16,
    marginBottom:8
  },
});

CreateUser.dataDependencies = ["Users"];

CreateUser.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( isLoggedIn ) return [];
  else
  {
    var didSelect = function() {appActions.requestFeatureName("CreateUser")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : 0,
    }];
  }
}

module.exports = CreateUser;



// WEBPACK FOOTER //
// ./src/CreateUser.js